import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

// Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location: "/".
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    label: 'Home',
    component: Home,
    redirect: 'eventView',
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/report',
    name: 'report',
    label: 'Report',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/WatchReport.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/eventView',
    name: 'eventView',
    label: 'Event View',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/EventView.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/landingPage',
    name: 'landingPage',
    label: 'Landing Page',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/LandingPage.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/whiteLabel',
    name: 'whiteLabel',
    label: 'White Label',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/LiveWhiteLabelView.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/liveFreeEticket',
    name: 'liveFreeEticket',
    label: 'E-Ticket',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/LiveFreeEticket.vue'),
    meta: {
      roles: ['SUPER_ADMIN'], // or you can only set roles in sub nav
    },
  },
  {
    path: '/enquiry',
    name: 'enquiry',
    label: 'CS Enquiry',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Enquiry.vue'),
    meta: {
      roles: ['SUPER_ADMIN', 'CS'], // or you can only set roles in sub nav
    },
  },
  {
    path: '/eventEnquiry',
    name: 'eventEnquiry',
    label: 'Event Enquiry',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/EventEnquiry.vue'),
    meta: {
      roles: ['SUPER_ADMIN'], // or you can only set roles in sub nav
    },
  },
  {
    path: '/whiteLabelVote',
    name: 'whiteLabelVote',
    label: 'White Label Vote',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/LiveWhiteLabelVoteView.vue'),
    meta: {
      roles: ['SUPER_ADMIN'], // or you can only set roles in sub nav
    },
  },
  {
    path: '/cache',
    name: 'cache',
    label: 'Event JSON Cache',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Cache.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/adminUser',
    name: 'adminUser',
    label: 'User View',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AdminUser.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    label: 'User Register',
    component: () => import('../views/Register.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/components/404.vue'),
  },
  {
    path: '/vpnVideo',
    name: 'vpnVideo',
    label: 'VPN Video',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/VpnVideo.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/presets',
    name: 'presets',
    label: 'Embed Presets',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Presets.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/chat',
    name: 'chat',
    label: 'Cityline Chat',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Chat.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/systemParameter',
    name: 'systemParameter',
    label: 'System Parameter',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SystemParameter.vue'),
    meta: {
      roles: ['SUPER_ADMIN'],
    },
  },
  // {
  //   path: '/dataPatch',
  //   name: 'dataPatch',
  //   label: 'Data Patch',
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '@/views/DataPatch.vue'),
  //   meta: {
  //     roles: ['SUPER_ADMIN'],
  //   },
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

Vue.prototype.$CDT_WEB_WHITE_LABEL_PREFIX = process.env.VUE_APP_URL_WHITE_LABEL_PREFIX

router.beforeEach((to, from, next) => {
  if (Vue.$cookies.get("cl_admin_token")) {
    from;
    // if(to.meta.roles){
    //   console.log(to.meta.roles.length);
    // } else {
    //   router.push('login');
    // }
    if (
      ['/login', '/404'].includes(to.path) ||
      (to.meta &&
        to.meta.roles &&
        to.meta.roles.includes(localStorage.getItem('cl_admin_role')))
    ) {
      // 直接通过
      next();
    } else {
      router.push('404');
    }
  } else if ('/login' === to.path) {
    next();
  } else {
    router.push('login');
  }

});

export default router;
